import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.6668 10.6667H6.94009L9.14009 8.47333C9.20258 8.41136 9.25217 8.33762 9.28602 8.25638C9.31987 8.17515 9.33729 8.08801 9.33729 8C9.33729 7.91199 9.31987 7.82486 9.28602 7.74362C9.25217 7.66238 9.20258 7.58864 9.14009 7.52667L6.94009 5.33333H10.6668C10.8436 5.33333 11.0131 5.2631 11.1382 5.13807C11.2632 5.01305 11.3334 4.84348 11.3334 4.66667C11.3334 4.48986 11.2632 4.32029 11.1382 4.19526C11.0131 4.07024 10.8436 4 10.6668 4H5.33343C5.20181 4.00066 5.07333 4.04026 4.96418 4.11381C4.85504 4.18737 4.77011 4.29159 4.72009 4.41333C4.66904 4.53474 4.65509 4.66855 4.68001 4.79788C4.70492 4.9272 4.76759 5.04625 4.86009 5.14L7.72676 8L4.86009 10.86C4.76759 10.9538 4.70492 11.0728 4.68001 11.2021C4.65509 11.3315 4.66904 11.4653 4.72009 11.5867C4.77011 11.7084 4.85504 11.8126 4.96418 11.8862C5.07333 11.9597 5.20181 11.9993 5.33343 12H10.6668C10.8436 12 11.0131 11.9298 11.1382 11.8047C11.2632 11.6797 11.3334 11.5101 11.3334 11.3333C11.3334 11.1565 11.2632 10.987 11.1382 10.8619C11.0131 10.7369 10.8436 10.6667 10.6668 10.6667Z",
      fill: "#334155"
    }, null, -1)
  ])))
}
export default { render: render }